import { useParams, Navigate } from "react-router-dom";
import DetailTemplate from "../components/DetailTemplate";
import { medicalConditionSchema } from "../seo/schemas";
import { SYMPTOM_CONTENT } from "../data/symptomContent";

export default function SymptomDetail() {
  const { slug } = useParams();
  const data = SYMPTOM_CONTENT[slug];
  if (!data) return <Navigate to="/symptoms" replace />;

  return (
    <DetailTemplate
      kind="Symptom"
      title={data.title}
      subtitle={data.subtitle}
      breadcrumb={[
        { label: "Symptoms", to: "/symptoms" },
        { label: data.shortTitle },
      ]}
      sections={data.sections}
      faq={data.faq}
      related={data.related}
      seo={{
        title: data.seoTitle,
        description: data.seoDescription,
        canonical: `/symptoms/${slug}`,
        extraSchemas: data.schema ? [medicalConditionSchema(data.schema)] : [],
      }}
    />
  );
}
